<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <img src="/static/img/logok.png" class="center-block logo">
          <div class="text-center col-sm-6 col-sm-offset-3">
            <h1>Requerimiento errado.</h1>
            <h4>La página solicitada no existe.</h4>
            <router-link to="/">Ir a inicio.</router-link>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'NotFound'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// 404.vue?55d28728